<kor-modal
  [visible]="visible"
  width="400px"
  height="auto"
  (visible-changed)="!$event.target.visible ? close.emit() : ''"
>
  <!-- header -->
  <img
    [src]="
      userService.user.image
        ? userService.user.image
        : 'assets/imgs/user-placeholder.png'
    "
    width="60"
    height="60"
  />
  <h1>{{ userService.user.name }}</h1>
  <br />
  <!-- body -->
  <div>
    <kor-menu-item
      label="🌙 dark theme"
      (click)="setColorTheme(); sharedService.logEvent('theme_toggle_clicked')"
      [toggle]="false"
    >
      <kor-toggle
        slot="functions"
        [active]="userService.user.colorTheme === 'dark'"
      ></kor-toggle>
    </kor-menu-item>
    <kor-menu-item
      label="🚪 sign out"
      (click)="signOut(); sharedService.logEvent('sign_out_clicked')"
    ></kor-menu-item>
  </div>
  <br />
</kor-modal>
